import service from '../utils/request'
// 根据ID获取详情
export const getempbyid = params => {return service.get(`/api/base_employee/get`, {params})};
// 查询列表
export const queryemp = params => {return service.post(`/api/base_employee/query`, params)};
// 创建员工
export const createemp = params => {return service.post(`/api/base_employee/create`,  params)};
// 设置密码
export const setpwd = params => {return service.get(`/api/base_employee/setpwd`, {params})};
// 修改密码
export const editpwd = params => {return service.get(`/api/base_employee/editpwd`, {params})};
// 刷新授权二维码
export const refreshauth = params => {return service.get(`/api/base_employee/refreshauth`, {params})};
// 操作授权码验证
export const employeeqrauth = params => {return service.post(`/api/base_employee/employeeqrauth`, params)};
// 修改员工
export const editemp = params => {return service.put(`/api/base_employee/edit`,  params)};
// 删除员工
export const deleteemp = params => {return service.delete(`/api/base_employee/delete`, {params})};